import { format } from "date-fns";
import React, { useState } from "react";

const UserTable = () => {
  const [date, setDate] = useState(Date.now());
  const today = format(date, "yyyy-MM-dd");

  const NameTable = {
    Name: "Peter Parker",
    SSN: "### ### 2314",
    DOB: "02-02-2002",
    FI: "Alabama Central Credit Union ",
    accNo: "### ### 1111",
    curAccBal: "$123.51",
  };

  return (
    <main>
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="py-2 inline-block min-w-full">
            <div className="overflow-hidden border border-border rounded p-0 m-0">
              <table className="min-w-full">
                <tbody className="text-left">
                  <tr className="border-b-[0.5px] border-border">
                    <th
                      scope="col"
                      className="px-4 py-[11px] text-xs font-semibold text-blackText"
                    >
                      Name :
                    </th>
                    <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                      {NameTable.Name}
                    </td>
                  </tr>
                  <tr className="border-b-[0.5px] border-border">
                    <th
                      scope="col"
                      className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
                    >
                      SSN :
                    </th>
                    <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                      {NameTable.SSN}
                    </td>
                  </tr>
                  <tr className="">
                    <th
                      scope="col"
                      className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
                    >
                      Report date :
                    </th>
                    <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                      {today}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default UserTable;
